import isEmpty from 'lodash/isEmpty';
import store from '../app/index';

function authorityGuard(authority: string[] = [], emptyCheck = false) {
  const { profile } = store.getState().auth;

  const roleMatched = authority.some((role) =>
    profile?.permissions?.includes(role)
  );

  if (
    isEmpty(authority) ||
    isEmpty(profile?.permissions) ||
    typeof authority === 'undefined'
  ) {
    return !emptyCheck;
  }

  return roleMatched;
}

export default authorityGuard;
